import { render, staticRenderFns } from "./matrix.vue?vue&type=template&id=79918904&"
import script from "./matrix.vue?vue&type=script&lang=js&"
export * from "./matrix.vue?vue&type=script&lang=js&"
import style0 from "./matrix.vue?vue&type=style&index=0&id=79918904&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports